import { RoutingPattern } from '../../Routes';

export const getTodoItemAdminUrl = (todoItemId: number) =>
    [RoutingPattern.todoAdmin, 'items', todoItemId].join('/');

export const categoriesAdminUrl = `${RoutingPattern.todoAdmin}/categories`;

export const getTodoItemUrl = (todoItemId: number) => `${RoutingPattern.todo}#${todoItemId}`;
